import { theme } from '../Styles/Theme.ts';
import { Burger, MediaQuery } from '@mantine/core';
import { CssObjectsVarios } from '../Styles/Varios.tsx';

export function BurgerToggleMenu({
    opened,
    toggleOpened,
}: {
    opened: boolean;
    toggleOpened: () => void;
}) {
    // @ts-ignore
    const color = opened ? theme.colors.celesteLuker[1] : undefined;
    return (
        <MediaQuery
            largerThan="sm"
            styles={CssObjectsVarios.displayNone}
        >
            <Burger
                opened={opened}
                onClick={toggleOpened}
                size="sm"
                mr="xl"
                color={color}
                style={burgerOcultarMenuStyle}
            />
        </MediaQuery>
    );
}
const burgerOcultarMenuStyle = {
    paddingTop: 40,
    paddingBottom: 40 /*, backgroundColor: 'red'*/,
};
